<template>
  <v-container
    v-if="selectedPlan !== null && selectedPlan !== undefined"
    fluid
    grid-list-md
  >
    <material-card :title="$t('views.downloadcenter.categories')" icon="list">
      <pbas-data-table
        ref="categoryTable"
        :dataProvider="categoryProvider"
        :floatActions="categoryActions"
        :rowActions="categoryRowActions"
        :selectActions="categorySelectActions"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>

    <material-card :title="$t('views.downloadcenter.files')" icon="description">
      <pbas-data-table
        ref="fileTable"
        :dataProvider="fileProvider"
        :rowActions="fileRowActions"
        :floatActions="fileActions"
        :selectActions="fileSelectActions"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>

    <v-dialog scrollable v-model="showCategoryEdit" max-width="800" persistent>
      <material-card
        :title="$t('views.downloadcenter.edit_category')"
        icon="list"
        :color="$vuetify.theme.themes.light.secondary"
      >
        <v-card-text v-if="showCategoryEdit && selectedCategory">
          <div class="row">
            <div class="col-12 align-self-center">
              <trans-textbox
                v-model="selectedCategory"
                :label="$t('globals.name')"
                field="Name"
                :disabled="false"
                :rules="[$rules.required]"
                class="required"
              ></trans-textbox>
            </div>
          </div>
          <div class="row">
            <div class="col-auto align-self-center">
              <no-autocomplete-textfield
                v-model="selectedCategory.Order"
                type="number"
                :label="$t('globals.priority')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </div>
            <div class="col-auto align-self-center">
              <icon-picker :icon.sync="selectedCategory.Icon"></icon-picker>
            </div>
          </div>
          <v-row>
            <div class="col-md-6 col-xs-12 align-self-center">
              <v-checkbox
                :label="$t('headers.downloadcategories.allow_guests')"
                v-model="selectedCategory.AllowedGuest"
              ></v-checkbox>
            </div>
            <div class="col-md-6 col-xs-12 align-self-center">
              <trans-multi-select2
                v-model="selectedCategory.Coverages"
                :items="coverages"
                :label="$t('headers.downloadcategories.allowed_coverages')"
                field="Name"
                itemValue="RemoteGuid"
              ></trans-multi-select2>
            </div>
          </v-row>
          <v-row>
            <!-- <div class="col-12 col-xs-12">
              <h3>{{ $t("components.plancreationwizard.classes") }}</h3>
              <DualListBoxSingleSelect
                :source="classes"
                :destination="selectedClasses"
                @add-destination="onAddCategoryClass"
                @add-source="onRemoveCategoryClass"
                :displayFunc1="(item) => item"
                :displayFunc2="(item) => item"
              ></DualListBoxSingleSelect>
            </div> -->
            <div class="col-12 col-xs-12">
              <v-autocomplete
                v-model="selectedClasses"
                :items="allClasses"
                :label="$t('components.plancreationwizard.classes')"
                multiple
              ></v-autocomplete>
            </div>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="showCategoryEdit = false" text>
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn @click="saveCategoryHandler" :loading="saving" color="primary">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog scrollable v-model="showFileEdit" max-width="1000" persistent>
      >
      <material-card
        :title="$t('views.downloadcenter.edit_file')"
        icon="description"
        :color="$vuetify.theme.themes.light.secondary"
      >
        <v-card-text v-if="showFileEdit && selectedFile">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <auto-select
                :label="$t('globals.category')"
                :value.sync="selectedFile.Category"
                :items="categoriesWithEmpty"
                :item-text="getCategoryName"
                item-value="Id"
                :rules="[$rules.required]"
                class="required"
              ></auto-select>
            </div>
            <div class="col-md-6 col-xs-12">
              <no-autocomplete-textfield
                v-model="selectedFile.Order"
                type="number"
                :rules="[$rules.required]"
                :label="$t('globals.priority')"
                class="required"
              ></no-autocomplete-textfield>
            </div>
          </div>
          <div
            v-for="trans of selectedFile.Translations"
            v-bind:key="trans.LanguageCode"
          >
            <div class="row">
              <h5 style="margin-left:5px">{{ trans.LanguageName }}</h5>
            </div>
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <no-autocomplete-textfield
                  v-model="trans.DisplayName"
                  :label="$t('globals.name')"
                  :rules="[$rules.required]"
                  class="required"
                ></no-autocomplete-textfield>
              </div>
              <div class="col-md-6 col-xs-12" v-if="!trans.PhysicalFile">
                <file-uploader
                  ref="uploader"
                  :url="uploadUrl"
                  v-on:upload-started="onUploadStarted"
                  v-on:upload-error="onUploadError"
                  v-on:upload-completed="
                    onUploadCompleted($event, trans.LanguageCode)
                  "
                  :rules="[$rules.required]"
                  :autoUpload="true"
                  class="required"
                />
              </div>
              <div
                class="col-md-5 col-xs-12 align-self-center"
                v-if="trans.PhysicalFile"
              >
                <v-row row no-gutters class="flex-nowrap" align="center">
                  <v-col class="col-md-8">
                    <a
                      target="_blank"
                      :href="trans.PhysicalFile.Path + '?attach'"
                    >
                      {{ trans.PhysicalFile.Name }}
                    </a>
                  </v-col>
                  <v-col class="col-auto">
                    <v-btn
                      icon
                      @click="
                        trans.PhysicalFile = null;
                        trans.PhysicalFileId = undefined;
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
          <div>
            <v-row>
              <div class="col-md-6 col-xs-12">
                <v-checkbox
                  :label="$t('headers.downloadcategories.allow_guests')"
                  v-model="selectedFile.AllowedGuest"
                ></v-checkbox>
              </div>
              <div class="col-md-6 col-xs-12">
                <trans-multi-select2
                  v-model="selectedFile.Coverages"
                  :items="coverages"
                  :label="$t('headers.downloadcategories.allowed_coverages')"
                  field="Name"
                  itemValue="RemoteGuid"
                ></trans-multi-select2>
              </div>
              <div class="col-12 col-xs-12">
                <v-autocomplete
                  v-model="selectedClasses"
                  :items="allClasses"
                  :label="$t('components.plancreationwizard.classes')"
                  multiple
                ></v-autocomplete>
              </div>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="showFileEdit = false" text>
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="loading"
            @click="saveFileHandler"
            :loading="saving"
            color="primary"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import TransMultiSelect2 from "../components/TransMultiSelect2";
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import DownloadCategoriesHeaders from "../headers/DownloadCategories";
import DownloadFilesHeaders from "../headers/DownloadFiles";
import TransTextbox from "../components/TransTextbox";
import FileUploader from "../components/FileUploader";
import IconPicker from "../components/IconPicker";
import store from "@/store";
import AutoSelect from "../components/AutoSelect";
import DualListBoxSingleSelect from "../components/DualListboxSingleSelect";
import ErrorHandler from "../components/ErrorHandler";
import { ODataHeader, ODataString } from "pbas-vue-components";
import { translate2 } from "../trans2";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { portalPermission } from "../mixins/portalPermission";

export default {
  components: {
    TransTextbox,
    FileUploader,
    TransMultiSelect2,
    IconPicker,
    AutoSelect,
    DualListBoxSingleSelect,
    ErrorHandler,
    NoAutocompleteTextfield,
  },
  mixins: [planSetter, portalPermission],
  data() {
    return {
      error: null,
      allClasses: [],
      selectedClasses: [],
      classes: [],
      file: undefined,
      loading: false,
      saving: false,
      showFileEdit: false,
      showCategoryEdit: false,
      categoryProvider: undefined,
      fileProvider: undefined,
      selectedCategory: undefined,
      selectedFile: { CategoryId: undefined },
      uploadUrl: undefined,
      categories: [],
      coverages: [],
      categoriesWithEmpty: [],
      categoryRowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (e) => {
            this.selectedCategory = this.deepCopy(e);
            if (
              this.selectedCategory &&
              this.selectedCategory.ClassDownloadCategoryRelations
            ) {
              this.selectedClasses = this.selectedCategory.ClassDownloadCategoryRelations.map(
                (o) => o.ClassDownloadCenterCategory.Class
              );
            } else {
              this.selectedClasses = [];
            }
            // this.classes = this.allClasses.filter(
            //   (o) => this.selectedClasses.filter((c) => c === o).length === 0
            // );
            // console.log(this.classes, this.allClasses, this.selectedClasses);
            this.showCategoryEdit = true;
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (e) => {
            this.deleteCategoriesHandler(e);
          },
        },
      ],
      fileRowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (e) => {
            this.selectedFile = this.deepCopy(e);
            // this.selectedFile.CategoryId = undefined;
            const languages = store.getters["common/languages"];
            for (var l of languages) {
              if (
                !this.selectedFile.Translations.some(
                  (t) => t.LanguageCode == l.language
                )
              ) {
                this.selectedFile.Translations.push({
                  LanguageCode: l.language,
                  LanguageName: l.title,
                });
              } else {
                this.selectedFile.Translations.filter(
                  (t) => t.LanguageCode == l.language
                )[0].LanguageName = l.title;
              }
            }
            if (
              this.selectedFile &&
              this.selectedFile.ClassDownloadFileRelations
            ) {
              this.selectedClasses = this.selectedFile.ClassDownloadFileRelations.map(
                (o) => o.ClassDownloadCenterFile.Class
              );
            } else {
              this.selectedClasses = [];
            }
            this.showFileEdit = true;
            this.$nextTick(() => {
              if (this.$refs.uploader) {
                this.$refs.uploader.forEach((u) => u.reset());
              }
            });
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (e) => {
            this.deleteFilesHandler(e);
          },
        },
        /*{
          name: "move_up",
          icon: "keyboard_arrow_up",
          title: "views.downloadcenter.move_up",
          handler: e => {
            const index = this.fileProvider.items.indexOf(e);
            const previous = this.fileProvider.items[index - 1];
            this.fileProvider.items[index - 1] = e;
             this.fileProvider.items[index] = previous;
          },
          visible:(item) =>{
            return this.fileProvider.items.indexOf(item) != 0;
          }
        },
        {
          name: "move_down",
          icon: "keyboard_arrow_down",
          title: "views.downloadcenter.move_down",
          handler: e => {

          },
          visible:(item) =>{
            return this.fileProvider.items.indexOf(item) != this.fileProvider.items.length - 1;
          }
        }*/
      ],
      categorySelectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (e) => {
            this.deleteCategoriesHandler(e);
          },
        },
      ],
      fileSelectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (e) => {
            this.deleteFilesHandler(e);
          },
        },
      ],
      categoryActions: [
        {
          name: "Add",
          text: "globals.add_new",
          color: this.$vuetify.theme.themes.light.success,
          icon: "add",
          handler: () => {
            this.selectedCategory = {
              PlanId: this.selectedPlan.Id,
              Name: "",
              Translations: [],
              Files: [],
              Order: 0.0,
            };
            this.selectedClasses = [];
            // this.classes = this.allClasses.filter((o) => true);
            // console.log(this.classes, this.allClasses, this.selectedClasses);
            this.showCategoryEdit = true;
          },
        },
      ],
      fileActions: [
        {
          name: "Add",
          text: "globals.add_new",
          color: this.$vuetify.theme.themes.light.success,
          icon: "add",
          handler: () => {
            const languages = store.getters["common/languages"];
            this.selectedFile = {
              Translations: [],
              Order: 0.0,
            };
            for (var l of languages) {
              this.selectedFile.Translations.push({
                DisplayName: "",
                LanguageCode: l.language,
                LanguageName: l.title,
              });
            }
            this.selectedClasses = [];
            this.showFileEdit = true;
            this.$nextTick(() => {
              if (this.$refs.uploader)
                this.$refs.uploader.forEach((u) => u.reset());
            });
          },
        },
      ],
      headers: DownloadCategoriesHeaders,
      fileHeaders: DownloadFilesHeaders,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("downloadCenter", [
      "getCategories",
      "getFiles",
      "saveCategory",
      "deleteCategory",
      "saveFile",
      "deleteFile",
    ]),
    ...mapActions("plansMembers", [
      "getCoverageByDate",
      "getPlan",
      "getCoverageIdentities",
    ]),
    async loadPlanData() {
      this.uploadUrl = this.settings.APIURL + "cms/PhysicalFile/Upload";
      await this.refresh();
    },
    async refresh() {
      try {
        this.coverages = (await this.getCoverageByDate({
          plan: this.selectedPlan.Id,
          date: new Date().toISOString(),
        })).data.value;
        this.coverages = this.coverages.map((c) => {
          return {
            Name: c.Name,
            RemoteGuid: c.IdentityId,
          };
        });
        const plan = (await this.getPlan(this.selectedPlan.Id)).data;
        this.allClasses =
          plan && plan.Current.Classes
            ? JSON.parse(plan.Current.Classes).sort((a, b) => {
                return a.localeCompare(b);
              })
            : [];

        let allCoverage = (await this.getCoverageIdentities({
          plan: this.selectedPlan.Id,
        })).value;
        this.categoryProvider = new ODataProvider(
          this.$axiosHttp,
          this.settings.APIURL +
            "cms/odata/Plans(" +
            this.selectedPlan.Id +
            ")/DownloadCenterCategories",
          this.headers.concat([
            new ODataHeader({
              title: "globals.coverage",
              type: new ODataString("Coverages[]", {
                getString: (item) => {
                  // console.log(item);
                  let cov = item.Coverages;
                  // console.log(cov)
                  let itemCov = allCoverage.filter((o) => {
                    // console.log(cov, o);
                    return (
                      cov && cov.filter((c) => c.RemoteGuid === o.Id).length > 0
                    );
                  });
                  // console.log(itemCov)
                  return itemCov
                    .map((o) => translate2(o.Current, "Name"))
                    .join(", ");
                },
                getHtml: (item, type) => {
                  return (
                    "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
                    type.getString(item, type) +
                    "</div>"
                  );
                },
              }),
              visible: true,
              allowVisibilityChange: true,
              searchable: true,
              sortable: false,
            }),
          ])
        );
        const categories = (await this.categoryProvider.fetchAsync()).items;
        this.categoriesWithEmpty = [{ Id: "" }, ...categories];

        this.fileProvider = new ODataProvider(
          this.$axiosHttp,
          this.settings.APIURL +
            "cms/odata/Plans(" +
            this.selectedPlan.Id +
            ")/DownloadCenterFiles",
          this.fileHeaders.concat([
            new ODataHeader({
              title: "globals.coverage",
              type: new ODataString("Coverages[]", {
                getString: (item) => {
                  // console.log(item);
                  let cov = item.Coverages;
                  // console.log(cov)
                  let itemCov = allCoverage.filter((o) => {
                    // console.log(cov, o);
                    return (
                      cov && cov.filter((c) => c.RemoteGuid === o.Id).length > 0
                    );
                  });
                  // console.log(itemCov)
                  return itemCov
                    .map((o) => translate2(o.Current, "Name"))
                    .join(", ");
                },
                getHtml: (item, type) => {
                  return (
                    "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
                    type.getString(item, type) +
                    "</div>"
                  );
                },
              }),
              visible: true,
              allowVisibilityChange: true,
              searchable: true,
              sortable: false,
            }),
          ])
        );

        this.$refs.categoryTable.selected = [];
        this.$refs.fileTable.selected = [];
        await this.$refs.categoryTable.getDataAsync();
        await this.$refs.fileTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
    onUploadCompleted(res, lang) {
      const trans = this.selectedFile.Translations.filter(
        (f) => f.LanguageCode == lang
      )[0];
      trans.PhysicalFileId = res.Id;
      trans.PhysicalFile = undefined;
      this.loading = false;
    },
    onUploadStarted() {
      this.loading = false;
    },
    onUploadError() {
      this.loading = false;
    },
    getCategoryName(cat) {
      if (!cat.Translations) {
        return "";
      }
      const lang = store.getters["common/language"].language;
      const filtered = cat.Translations.filter((t) => t.LanguageCode == lang);
      return filtered.length > 0 ? filtered[0].Name : "";
    },
    async saveCategoryHandler() {
      this.saving = true;
      try {
        let category = JSON.parse(JSON.stringify(this.selectedCategory));
        delete category.Name;
        if (category.Coverages) {
          for (let c of category.Coverages) {
            delete c.Name;
          }
        }
        category.ClassDownloadCategoryRelations = [];
        if (this.selectedCategory.ClassDownloadCategoryRelations) {
          for (let classCategoryRelation of this.selectedCategory
            .ClassDownloadCategoryRelations) {
            if (
              this.selectedClasses.filter(
                (o) => o === classCategoryRelation.Class
              ).length > 0
            ) {
              delete classCategoryRelation.DownloadCenterCategory;
              delete classCategoryRelation.ClassDownloadCenterCategory;
              category.ClassDownloadCategoryRelations.push(
                classCategoryRelation
              );
            }
          }
        } else {
          this.selectedCategory.ClassDownloadCategoryRelations = [];
        }

        for (let classStr of this.selectedClasses) {
          if (
            this.selectedCategory.ClassDownloadCategoryRelations.filter(
              (o) => o.Class === classStr
            ).length === 0
          ) {
            category.ClassDownloadCategoryRelations.push({
              DownloadCategoryId: this.selectedCategory.Id,
              ClassDownloadCenterCategory: {
                Class: classStr,
                PlanId: this.selectedPlan.Id,
              },
            });
          }
        }
        await this.saveCategory(category);
        this.showCategoryEdit = false;
        await this.refresh();
      } catch (e) {
        console.error(e);
      } finally {
        this.saving = false;
      }
    },
    async saveFileHandler() {
      this.saving = true;
      try {
        let file = JSON.parse(JSON.stringify(this.selectedFile));
        if (file.Category) {
          file.CategoryId = file.Category.Id;
          delete file.Category;
        } else {
          file.CategoryId = null;
        }
        file.Translations = file.Translations.filter(
          (o) =>
            (o.PhysicalFileId !== null && o.PhysicalFileId !== undefined) ||
            (o.PhysicalFile !== null && o.PhysicalFile !== undefined)
        );
        for (var t of file.Translations) {
          delete t.LanguageName;
          if (t.PhysicalFile && t.PhysicalFile.Id) {
            t.PhysicalFileId = t.PhysicalFile.Id;
            delete t.PhysicalFile;
          }
        }
        if (file.Coverages) {
          for (let c of file.Coverages) {
            delete c.Name;
          }
        }
        file.ClassDownloadFileRelations = [];
        if (this.selectedFile.ClassDownloadFileRelations) {
          for (let classFileRelation of this.selectedFile
            .ClassDownloadFileRelations) {
            if (
              this.selectedClasses.filter((o) => o === classFileRelation.Class)
                .length > 0
            ) {
              delete classFileRelation.DownloadCenterFile;
              delete classFileRelation.ClassDownloadCenterFile;
              file.ClassDownloadFileRelations.push(classFileRelation);
            }
          }
        } else {
          this.selectedFile.ClassDownloadFileRelations = [];
        }

        for (let classStr of this.selectedClasses) {
          if (
            this.selectedFile.ClassDownloadFileRelations.filter(
              (o) => o.Class === classStr
            ).length === 0
          ) {
            file.ClassDownloadFileRelations.push({
              DownloadFileId: this.selectedFile.Id,
              ClassDownloadCenterFile: {
                Class: classStr,
                PlanId: this.selectedPlan.Id,
              },
            });
          }
        }
        await this.saveFile(file);
        this.showFileEdit = false;
        await this.refresh();
      } catch (e) {
        console.error(e);
      } finally {
        this.saving = false;
      }
    },
    async deleteCategoriesHandler(item) {
      await this.deleteCategory(item);
      await this.refresh();
    },
    async deleteFilesHandler(item) {
      await this.deleteFile(item);
      await this.refresh();
    },
    deepCopy(inObject) {
      let outObject, value, key;

      if (typeof inObject !== "object" || inObject === null) {
        return inObject; // Return the value if inObject is not an object
      }

      // Create an array or object to hold the values
      outObject = Array.isArray(inObject) ? [] : {};

      for (key in inObject) {
        value = inObject[key];

        // Recursively (deep) copy for nested objects, including arrays
        outObject[key] = this.deepCopy(value);
      }

      return outObject;
    },
  },
};
</script>

<style>
.svg-icon svg,
.svg-icon svg path {
  /* fill: #222222 !important;*/
}
</style>
